import { ChangeDetectionStrategy, Component } from "@angular/core";
import { NewUiLogoutComponent } from "./new-ui-logout.component";

@Component({
  selector: "app-logout",
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoutComponent extends NewUiLogoutComponent {}
